import { styled } from '@mui/material/styles';
import { TURN_STYLES } from '@/styles/theme';

export const Input = styled('input')(({ theme }) => ({
  width: 256,
  height: 42,
  padding: '8.5px 14px',
  fontSize: 14,
  color: theme.palette.mode === 'dark' ? TURN_STYLES.darkSecondaryColor : TURN_STYLES.primaryColor,
  backgroundColor: theme.palette.mode === 'dark' ? TURN_STYLES.darkSurfaceColor : 'white',
  border: `1px solid ${theme.palette.mode === 'dark' ? TURN_STYLES.darkBorderColor : TURN_STYLES.borderColor}`,
  borderRadius: 8,

  '&:hover': {
    borderColor: TURN_STYLES.primaryAccentColor,
  },

  '&:focus-visible': {
    borderColor: TURN_STYLES.primaryAccentColor,
    outline: 'none',
  },
}));
